var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCheck(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "20px",
    height: "14px",
    viewBox: "0 0 20 14",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Shape") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Wires-V2",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "GlidePath_-Sex-Copy-2",
    transform: "translate(-264.000000, -533.000000)",
    fill: "#79DD01",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M283.763393,533.232398 C283.447886,532.922534 282.936362,532.922534 282.620854,533.232398 L270.552922,545.084421 L265.379131,540.003179 C265.063662,539.693315 264.5521,539.693315 264.236631,540.003179 C263.921123,540.313043 263.921123,540.815417 264.236631,541.125281 L269.98171,546.767592 C270.139445,546.922544 270.346242,547 270.553,547 C270.759758,547 270.966554,546.922544 271.124289,546.767554 L283.763433,534.3545 C284.078862,534.044674 284.078862,533.5423 283.763393,533.232398 Z",
    id: "Shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheck);
export default __webpack_public_path__ + "static/media/check.7bb6a9d4.svg";
export { ForwardRef as ReactComponent };